import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { isEqual } from "@utils/lodash";

class Loader extends Component {
	shouldComponentUpdate = ({
		active,
		white,
		topSmall,
		spinnerOnly,
		absolute,
		className,
		size,
	}) => {
		const lastProps = this.props;
		return (
			!isEqual(active, lastProps.active) ||
			!isEqual(white, lastProps.white) ||
			!isEqual(topSmall, lastProps.topSmall) ||
			!isEqual(spinnerOnly, lastProps.spinnerOnly) ||
			!isEqual(absolute, lastProps.absolute) ||
			!isEqual(className, lastProps.className) ||
			!isEqual(size, lastProps.size)
		);
	};

	render() {
		const { spinnerOnly, size, active, absolute, className, white, topSmall } = this.props;

		const spinner = (
			<i
				className={classNames("display-inline-block rkf rkf-spinner rkf-spin rkf-fw", {
					"rkf-4x": size === "big",
					"rkf-2x": size === "small",
					hidden: spinnerOnly && !active,
				})}
			/>
		);

		return (
			<Choose>
				<When condition={spinnerOnly}>{spinner}</When>
				<Otherwise>
					<div
						className={classNames("loader", className, {
							active,
							"position-absolute": absolute,
							"color-white": white,
							"top-small-loader": topSmall,
						})}
					>
						{spinner}
					</div>
				</Otherwise>
			</Choose>
		);
	}
}

Loader.propTypes = {
	active: PropTypes.bool,
	white: PropTypes.bool,
	topSmall: PropTypes.bool,
	spinnerOnly: PropTypes.bool,
	absolute: PropTypes.bool,
	className: PropTypes.string,
	size: PropTypes.oneOf(["small", "big"]),
};

Loader.defaultProps = {
	active: false,
	white: false,
	topSmall: false,
	spinnerOnly: false,
	absolute: false,
	className: "",
	size: "big",
};

export default Loader;
